module.exports = __webpack_public_path__ + "img/郁金香-2.a2d6f49a.jpg";